import { request } from '../api.js';
import type { InboxResponse, InboxUnreadCountResponse } from '@cosvision/shared';

export function getInboxUnreadCount(): Promise<InboxUnreadCountResponse> {
  return request<InboxUnreadCountResponse>('get', '/inbox/unread-count');
}

export function getInbox(): Promise<InboxResponse> {
  return request<InboxResponse>('get', '/inbox');
}
